import React, { useEffect, useState } from "react";
import { Button, Table } from "antd"; // Import Table from Ant Design

function GarmentsDetails({ allData }) {
  console.log(allData);
  const [data, setData] = useState([]);
  // const [dataLimit, setDataLimit] = useState({}); // Default limit

  useEffect(() => {
    setData(allData);

    // Initialize dataLimit for each item
    if (allData && allData.length > 0) {
      const initialLimits = {};
      allData.forEach((_, index) => {
        initialLimits[index] = 3; // Set default to show first 3 items
      });
      // setDataLimit(initialLimits);
    }
  }, [allData]);

  // const handleViewAll = (index) => {
  //   setDataLimit((prevLimits) => ({
  //     ...prevLimits,
  //     [index]: prevLimits[index] === 3 ? (data[index].items.length || 0) : 3,
  //   }));
  // };

  // Define columns for the items table
  const itemsColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Discount",
      dataIndex: "discount",
      key: "discount",
    },
    {
      title: "Purchase Amount",
      dataIndex: "purchaseAmount",
      key: "purchaseAmount",
    },
    {
      title: "Selling Amount",
      dataIndex: "sellingAmount",
      key: "sellingAmount",
    },
    {
      title: "Gross Profit",
      dataIndex: "grossProfit",
      key: "grossProfit",
    },
  ];

  // Define columns for the purchases table
  const purchasesColumns = [
    {
      title: "Remark",
      dataIndex: "remark",
      key: "remark",
    },
    {
      title: "Purchase Amount",
      dataIndex: "purchaseAmount",
      key: "purchaseAmount",
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
    },
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        {data && data.length > 0 ? (
          data.map((item, index) => (
            <div key={index} className="col-12 mb-4">
              <h5 className="shop-heading mb-2">{item.shop?.name}</h5>
              <div className="card">
                <div className="card-body">
                  <h5 className="text-danger">Items</h5>
                  {/* Items Section */}
                  {item.items && item.items.length > 0 ? (
                    <div className="table-responsive mb-4">
                      <Table
                        dataSource={item.items}
                        columns={itemsColumns}
                        pagination={false}
                        rowKey={(record) => record.id}
                      />
                      {/* {item.items.length > 3 && (
                        <Button onClick={() => handleViewAll(index)} block>
                          {dataLimit[index] === 3 ? "View All" : "Show Less"}
                        </Button>
                      )} */}
                    </div>
                  ) : (
                    <div className="border rounded p-4 mb-2">
                      <p>No services available</p>
                    </div>
                  )}

                  <h5 className="text-danger">Purchases</h5>
                  {/* Purchases Section */}
                  {item.purchases && item.purchases.length > 0 ? (
                    <div className="table-responsive mb-4">
                      <Table
                        dataSource={item.purchases}
                        columns={purchasesColumns}
                        pagination={false}
                        rowKey={(record) => record.id}
                      />
                    </div>
                  ) : (
                    <div className="border p-4 mb-2">
                      <p>No live details available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 mb-4">
            <div className="card text-center">
              <div className="card-body">
                <p>No data available</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default GarmentsDetails;
